import { apiClient } from './client';
import type { Order } from '../types';

interface OrdersResponse {
  orders: Order[];
  total: number;
  limit: number;
  offset: number;
}

export const ordersApi = {
  // Get orders list
  getOrders: (params?: { status?: string; limit?: number; offset?: number }) => {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());

    const query = queryParams.toString();
    return apiClient.get<OrdersResponse>(`/orders${query ? `?${query}` : ''}`);
  },

  // Get single order
  getOrder: (id: number) => apiClient.get<Order>(`/orders/${id}`),

  // Cancel order
  cancelOrder: (id: number, reason?: string) =>
    apiClient.patch<{ message: string }>(`/orders/${id}/cancel`, { reason }),
};
